<div class="login-card">
    <div>
        <div class="login-main">
            <div class="theme-form">
                <h4 style=" font-size: 22px;margin-bottom:20px">Complete your profile</h4>
                <p>Enter your personal details</p>
                <div class="form-group">
                    <label class="col-form-label pt-0">Your Name</label>
                    <div class="row">
                        <div class="col-6">
                            <input [disabled]="firstNameDisabled" [(ngModel)]="userRegistrationObj.firstName" class="form-control" type="text" required="" placeholder="First name">
                        </div>
                        <div class="col-6">
                            <input [disabled]="lastNameDisabled" [(ngModel)]="userRegistrationObj.lastName" class="form-control" type="text" required="" placeholder="Last name">
                        </div>
                    </div>
                </div>
                <div>
                    <label class="col-form-label">Mobile Number</label>
                    <div class="form-group">
                        <form class="example-form" style="padding: 0px;" [formGroup]="mobileLoginForm">
                            <ngx-mat-intl-tel-input [disabled]="phoneDisabled" style="background-color: #f3f3ff !important;" class="form-control" [preferredCountries]="['ae', 'sa', 'jo']"
                                                    [enablePlaceholder]="true"
                                                    [enableSearch]="true"
                                                    name="phone" formControlName="phone"
                                                    describedBy="phoneInput"></ngx-mat-intl-tel-input>
                        </form>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-form-label">Email Address</label>
                    <input [(ngModel)]="userRegistrationObj.emailAddress" [disabled]="emailDisabled" class="form-control" type="email" required="" placeholder="name@company.com">
                </div>
                <div class="form-group">
                    <!--<mat-form-field class="example-full-width" style="width:100%">-->
                    <label class="col-form-label">Organization</label>
                        <input type="text"
                               aria-label="Organization" class="form-control"
                               matInput
                               [formControl]="myControl" [(ngModel)]="userRegistrationObj.organization.name"
                               [matAutocomplete]="auto">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.Name">
                                <p (click)="getSelectedOrganization(option)">{{option.Name}}</p>
                            </mat-option>
                        </mat-autocomplete>
                    <!--</mat-form-field>-->
                </div>
                <div class="form-group mb-0">
                    <div class="checkbox p-0">
                        <input [(ngModel)]="terms" id="checkbox1" type="checkbox">
                        <label class="text-muted" for="checkbox1">Agree with<a class="ms-2" target="_blank" href="https://my.gistec.com/my.gistec/terms.html">Privacy Policy</a></label>
                    </div>
                    <button (click)="register()" class="btn btn-primary d-block w-100" type="button">Log in</button>
                    <p style=" margin-top: 20px;" *ngIf="email_exist_message">E-mail address already exist. <a [routerLink]="'/auth/login-email'">click here</a> to login using your Email Address</p>
                </div>
                <p class="mt-4 mb-0">Go Back?<a class="ms-2" [routerLink]="'/auth/login'">Click here</a></p>
            </div>
        </div>
    </div>
</div>